import React from 'react';
import useHelpers from '../../hooks/context/useHelpers';

export default function Modifier({ name, price, quantity, isNested }) {
  const { formatCurrency } = useHelpers();
  const modifierIcon = isNested ? '+' : '•';
  const quantityTitle = ` ${quantity}x`;

  return (
    <div className="flex flex-row justify-between">
      <div>
        {modifierIcon}
        {quantity > 1 && <span className="font-bold">{quantityTitle}</span>}
        &nbsp;
        {name}
      </div>
      <div>{formatCurrency(price)}</div>
    </div>
  );
}
